export type WhitelabelConfig = {
  appName: string;
  brandName: string;
  storeId: string;
  storeType: "seller";
  documentTitle: string;
  metaDescription: string;
  supportEmail: string;
  logos: {
    app: string;
    auth: string;
    favicon: string;
  };
  auth: {
    welcomeTitle: string;
    inviteTitle: string;
    loginSubtitle: string;
    inviteSubtitle: string;
    sideTagline: string;
    sideHeadlinePrefix: string;
    sideHeadlineHighlight: string;
    sideDescription: string;
    features: Array<{
      title: string;
      description: string;
    }>;
    stats: Array<{
      value: string;
      label: string;
    }>;
  };
  payments: {
    razorpayName: string;
  };
  shipping: {
    internalShippingLabel: string;
  };
  theme: {
    cssVars: Record<string, string>;
  };
};

export const whitelabelConfig: WhitelabelConfig = {
  appName: "Shiphouse Seller Admin",
  brandName: "Shiphouse",
  storeId: "98f61db7-c0f1-4c6e-a173-b0258c33c501",
  storeType: "seller",
  documentTitle: "Shiphouse Seller Admin",
  metaDescription: "Seller website builder and admin panel",
  supportEmail: "support@shiphouse.in",
  logos: {
    app: "/assets/logo.png",
    auth: "/assets/auth/logo.png",
    favicon: "/favicon.ico",
  },
  auth: {
    welcomeTitle: "Welcome to Shiphouse",
    inviteTitle: "Join via Invite",
    loginSubtitle: "Log in to manage your store and website.",
    inviteSubtitle: "You have been invited to join Shiphouse. Enter your details to get started.",
    sideTagline: "Seller Website Builder",
    sideHeadlinePrefix: "Build Your",
    sideHeadlineHighlight: "Seller Website",
    sideDescription: "Create, manage, and grow your online store from one seller-focused workspace.",
    features: [
      {
        title: "Fast Setup",
        description: "Get your store running in minutes",
      },
      {
        title: "Product Catalog",
        description: "Manage products, collections, and inventory",
      },
      {
        title: "Sales Insights",
        description: "Track performance from one dashboard",
      },
    ],
    stats: [
      { value: "50K+", label: "Sellers" },
      { value: "$2M+", label: "Revenue" },
      { value: "99.9%", label: "Uptime" },
    ],
  },
  payments: {
    razorpayName: "Shiphouse",
  },
  shipping: {
    internalShippingLabel: "Shiphouse Shipping",
  },
  theme: {
    cssVars: {
      "--primary": "#5659ff",
      "--primary-foreground": "#ffffff",
      "--shadow-brand": "0px 2px 4px 0px rgba(86, 89, 255, 0.3)",
    },
  },
};

export function applyWhitelabelTheme() {
  if (typeof document === "undefined") return;

  Object.entries(whitelabelConfig.theme.cssVars).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value);
  });
}
